var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2493 10.2187L7.19993 4.31656L7.20684 4.32209L10.858 0.0917969H9.63785L6.66356 3.53495L4.30161 0.0917969H1.10172L4.8822 5.60223L4.88174 5.60177L0.894531 10.2187H2.11464L5.42135 6.38798L8.04942 10.2187H11.2493ZM3.81817 1.01242L9.49972 9.29809H8.53285L2.84671 1.01242H3.81817Z",
    fill: "#111219"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.3b04bd49eaefdddc8671ac8b14f12207.svg";
export { ForwardRef as ReactComponent };